// src/routes/modules/dealerRoutes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import MasterLayout from '../../masterLayout/MasterLayout';

import ViewDealers from '../../pages/Dealer/ViewDealers';
import AddDealer   from '../../pages/Dealer/AddDealers';
import ViewDealer  from '../../pages/Dealer/ViewDealer';
import EditDealer  from '../../pages/Dealer/EditDealer';

const dealerRoutes = (
  <>
    <Route
      path="/dealer/view"
      element={
        <ProtectedRoute>
          <MasterLayout><ViewDealers /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/dealer/view/:id"
      element={
        <ProtectedRoute>
          <MasterLayout><ViewDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/dealer/add"
      element={
        <ProtectedRoute>
          <MasterLayout><AddDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/dealer/edit/:id"
      element={
        <ProtectedRoute>
          <MasterLayout><EditDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
  </>
);

export default dealerRoutes;